<template>
    <div class="block">
        <el-row>
            <el-col :span="16">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[20, 40, 60, 100]"
                    :page-size="pagesize"
                    layout="sizes, prev, pager, next"
                    :total="total"
                    :current-page="now"
                >
                </el-pagination>
            </el-col>
            <el-col :span="8">
                <el-select
                    v-model="value"
                    placeholder="Select"
                    @change="handleSortChange"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { defineComponent, toRef, ref } from "vue";

export default defineComponent({
    name: "withPagination",
    props: {
        hitsTotal: {
            type: Number,
            required: true,
        },
        currentPageSize: {
            type: Number,
            required: true,
        },
        sortingItems: {
            type: Object,
            required: true,
        },
        nowpage: {
            type: Number,
            required: true,
        },
        sortSelect: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const handleSizeChange = (val) => {
            context.emit("emittedhandleSizeChange", val);
        };
        const handleCurrentChange = (val) => {
            context.emit("emittedhadleCurrentChange", val);
        };
        const handleSortChange = (val) => {
            context.emit("emittedSortChange", val);
        };
        const total = toRef(props, "hitsTotal");
        const pagesize = toRef(props, "currentPageSize");
        const options = toRef(props, "sortingItems");
        const sortSelect = toRef(props, "sortSelect");
        const value = ref("");
        value.value = sortSelect.value;
        const now = toRef(props, "nowpage");
        /*
        watch(value, () => {
            context.emit("emittedSortChange", value);
        });
        */

        return {
            handleSizeChange,
            handleCurrentChange,
            handleSortChange,
            pagesize,
            total,
            options,
            value,
            now,
        };
    },
});
</script>

<style scoped></style>
